{
  "close": "Fechar",
  "notifications": "Notificações"
}
